import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import {
  Zap,
  Shield,
  Wifi,
  Monitor,
  Printer,
  HardDriveDownload,
  Smartphone,
  Globe,
} from 'lucide-react';
import { SILOS } from '../../data/blog/silos';
import type { SiloId } from '../../types/blog';

const SILO_ICONS: Record<SiloId, React.ReactNode> = {
  performance: <Zap className="h-5 w-5" />,
  securite: <Shield className="h-5 w-5" />,
  reseau: <Wifi className="h-5 w-5" />,
  windows: <Monitor className="h-5 w-5" />,
  materiel: <Printer className="h-5 w-5" />,
  recuperation: <HardDriveDownload className="h-5 w-5" />,
  telephone: <Smartphone className="h-5 w-5" />,
  'site-internet': <Globe className="h-5 w-5" />,
};

interface SiloNavProps {
  activeSilo?: SiloId;
}

const SiloNav: React.FC<SiloNavProps> = ({ activeSilo }) => {
  return (
    <nav aria-label="Catégories du blog" className="py-6">
      <motion.div
        className="flex flex-wrap justify-center gap-3"
        initial="hidden"
        animate="show"
        variants={{
          hidden: {},
          show: { transition: { staggerChildren: 0.06 } },
        }}
      >
        <motion.div
          variants={{
            hidden: { opacity: 0, y: 12 },
            show: { opacity: 1, y: 0, transition: { duration: 0.35, ease: 'easeOut' } },
          }}
        >
          <Link
            to="/blog"
            className={`inline-flex min-h-11 items-center gap-2 rounded-full px-4 py-2 text-sm font-medium border transition-all duration-200 ${
              activeSilo === undefined
                ? 'bg-accent-strong border-accent text-fg'
                : 'border-line-strong bg-white/5 text-fg-muted hover:border-accent/50 hover:text-fg'
            }`}
          >
            Tous les articles
          </Link>
        </motion.div>

        {(Object.keys(SILOS) as SiloId[]).map((siloId) => {
          const silo = SILOS[siloId];
          const isActive = activeSilo === siloId;
          return (
            <motion.div
              key={siloId}
              variants={{
                hidden: { opacity: 0, y: 12 },
                show: { opacity: 1, y: 0, transition: { duration: 0.35, ease: 'easeOut' } },
              }}
            >
              <Link
                to={`/blog/silo/${siloId}`}
                className={`inline-flex min-h-11 items-center gap-2 rounded-full px-4 py-2 text-sm font-medium border transition-all duration-200 ${
                  isActive
                    ? `bg-accent-strong border-transparent text-white`
                    : 'border-line-strong bg-white/5 text-fg-muted hover:border-white/30 hover:text-fg'
                }`}
              >
                {SILO_ICONS[siloId]}
                {silo.title}
              </Link>
            </motion.div>
          );
        })}
      </motion.div>
    </nav>
  );
};

export default SiloNav;
